module.exports = __webpack_public_path__ + "img/help_email.42d66f1b.svg";